import React from "react";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { RegionDataType } from "@data-types/membership/registration";

export default function OnboardingRegistrationState(props: {
	countryRegionsData: RegionDataType[] | null;
	labelClassName: string;
}) {
	const { countryRegionsData, labelClassName } = props;

	return (
		<FormSelectField
			className="form__field u-mar--bottom--reset"
			inputClassName="input input--sml input--select"
			name="regionId"
			label="registration:STATE_LABEL"
			labelClassName={labelClassName}
			dropdownData={countryRegionsData}
			placeholder="registration:STATE_PLACEHOLDER"
			required
		/>
	);
}
